import { useEcomStoreSelector } from 'data/state';

const useKioskBasePath = () => {
  const { treez_store_name } = useEcomStoreSelector(['treez_store_name']);

  return { basePath: `/kiosk/${treez_store_name}` };
};

export { useKioskBasePath };
